import React from "react";

function LoadingSpinner({ message = "Loading..." }) {
    return (
        <div className="loading">
            <div className="spinner" />
            <span style={{ marginLeft: 12 }}>{message}</span>
        </div>
    );
}

export default LoadingSpinner;
